module.exports = __webpack_public_path__ + "media/flags/ma-6d9acf19.svg";